const getBaseUrl = (): Readonly<string> => {
  let url

  if (process.env.NEXT_PUBLIC_VERCEL_PROJECT_PRODUCTION_URL) {
    url = `https://${process.env.NEXT_PUBLIC_VERCEL_PROJECT_PRODUCTION_URL}`
  } else if (process.env.NEXT_PUBLIC_VERCEL_URL) {
    url = `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`
  } else {
    url = 'http://localhost:3000'
  }

  // Remove trailing slash
  return url.replace(/\/+$/, '')
}

export const baseUrl: Readonly<string> = getBaseUrl()
